import * as React from 'react';
import * as styles from './styles.css';

import { Button, UIHeading4 } from '@cian/ui-kit';

export interface IRateOurEstimationRootProps {
  isLoading?: boolean;
  onOpenModal(): void;
  onSuccess(): void;
}

export const RateOurEstimationRoot: React.FC<IRateOurEstimationRootProps> = ({ onOpenModal, onSuccess, isLoading }) => {
  return (
    <div data-testid="RateOurEstimationRoot" className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading4>Согласны с оценкой?</UIHeading4>
      </div>
      <div className={styles['buttons']}>
        <div data-testid="btn_onSuccess" className={styles['button']}>
          <Button theme="fill_secondary" size="M" fullWidth={true} loading={isLoading} onClick={onSuccess}>
            Да
          </Button>
        </div>
        <div data-testid="btn_onOpenModal" className={styles['button']}>
          <Button theme="fill_secondary" size="M" fullWidth onClick={onOpenModal}>
            Нет
          </Button>
        </div>
      </div>
    </div>
  );
};

RateOurEstimationRoot.displayName = 'RateOurEstimationRoot';
